module.exports = __webpack_public_path__ + "static/media/camera-alt.7fc73902.svg";